<script setup lang="ts">
definePageMeta({
  layout: 'blank',
});
</script>

<template>
  <BaseMaintenance />
</template>
